import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-right-triangle",
  "use": "icon-icon-right-triangle-usage",
  "viewBox": "0 0 10.902 14.423",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.902 14.423\" id=\"icon-icon-right-triangle\">\n  <path id=\"icon-icon-right-triangle_Path_90\" data-name=\"Path 90\" d=\"M10.83,0V14.422l10.9-7.211L19.289,5.594Z\" transform=\"translate(-10.83 0)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol